import React, { createContext, useContext, useEffect, useState } from "react";

const TelegramContext = createContext();

export const TelegramProvider = ({ children }) => {
  const [tg, setTg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isTelegram, setIsTelegram] = useState(true);

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      const telegram = window.Telegram.WebApp;
      telegram.ready();
      telegram.expand();
      setTg(telegram);
      setIsTelegram(true);
    } else {
      setIsTelegram(false);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <p>Завантаження...</p>;
  }

  if (!isTelegram) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <h2>Будь ласка, відкрийте додаток через Telegram</h2>
        <p>Mini-app доступний лише всередині Telegram.</p>
      </div>
    );
  }

  return (
    <TelegramContext.Provider value={tg}>{children}</TelegramContext.Provider>
  );
};

export const useTelegram = () => {
  return useContext(TelegramContext);
};
